import { Component, OnInit } from '@angular/core';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import { moduli } from '../../config';
import { NaruceneKolicineGrupeService } from './narucene-kolicine-grupe.service';

@Component({
  selector: 'app-narucene-kolicine-grupe',
  templateUrl: './narucene-kolicine-grupe.component.html',
  styleUrls: ['./narucene-kolicine-grupe.component.scss'],
})
export class NaruceneKolicineGrupeComponent implements OnInit {
  naruceneKolicine: any;
  od = moment().format('YYYY-MM-DD');
  do = moment().format('YYYY-MM-DD');
  grupa = null;
  grupe: any;
  datumOd = moment();
  datumDo = moment();

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(private service: NaruceneKolicineGrupeService) {
    this.dohvatiGrupePartnera();

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().naruceneKolicinePoGrupi;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  ngOnInit() {
    this.dohvatiNaruceneKolicine(this.od, this.do, this.grupa);
  }

  dohvatiNaruceneKolicine(
    datumOd: string,
    datumDo: string,
    partnerGrupa: number
  ) {
    this.naruceneKolicine = [];
    let data = {
      datumod: datumOd,
      datumdo: datumDo,
      idpartnergrupa: partnerGrupa,
    };
    console.log(data);
    this.service.dohvatiNaruceneKolicine(data).subscribe((res) => {
      console.log(res);
      this.naruceneKolicine = res.data;
    });
  }

  dohvatiGrupePartnera() {
    this.grupe = [];
    this.service.dohvatiGrupePartnera({}).subscribe((res) => {
      console.log(res);
      this.grupe = [{ idpartnergrupa: null, pg_naziv: 'SVE' }, ...res.data];
    });
  }

  promjenaDatumOd(e) {
    this.datumOd = e.value;
    this.od = moment(e.value).format('YYYY-MM-DD');
    this.dohvatiNaruceneKolicine(this.od, this.do, this.grupa);
  }

  promjenaDatumDo(e) {
    this.do = moment(e.value).format('YYYY-MM-DD');
    this.dohvatiNaruceneKolicine(this.od, this.do, this.grupa);
  }

  promjenaGrupe(e) {
    this.grupa = e.value;
    this.dohvatiNaruceneKolicine(this.od, this.do, this.grupa);
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }
}
